import type { SVGProps } from 'react';

export const Security = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{'security'}</title>
    <g>
      <path
        d="M15.875 21C15.663 21 15.459 20.9123 15.309 20.7548L11.234 16.7541C11.084 16.5976 11 16.3857 11 16.1635C11 15.9412 11.084 15.7294 11.234 15.5739L11.801 14.9833C11.957 14.8205 12.161 14.7391 12.366 14.7391C12.571 14.7391 12.775 14.8205 12.932 14.9833L15.875 17.8696L21.068 12.2442C21.218 12.0877 21.422 12 21.634 12C21.846 12 22.05 12.0877 22.2 12.2442L22.766 12.8337C23.078 13.1603 23.078 13.6894 22.766 14.015L16.441 20.7548C16.291 20.9123 16.087 21 15.875 21Z"
        fill={props.fill}
      />
      <path
        d="M29.8455 8.23939C29.8291 7.37544 29.8134 6.55928 29.8134 5.76969C29.8134 5.15111 29.3122 4.64962 28.6937 4.64962C23.905 4.64962 20.2591 3.27296 17.22 0.31715C16.7853 -0.105791 16.0934 -0.105642 15.6588 0.31715C12.62 3.27296 8.97469 4.64962 4.18633 4.64962C3.56795 4.64962 3.06661 5.15111 3.06661 5.76969C3.06661 6.55943 3.05109 7.37589 3.03451 8.23999C2.88104 16.2801 2.67083 27.2913 16.0727 31.9382C16.1915 31.9794 16.3154 32 16.4393 32C16.5632 32 16.6873 31.9794 16.806 31.9382C30.2089 27.2912 29.999 16.2796 29.8455 8.23939ZM16.4395 29.6913C4.94565 25.5146 5.11943 16.365 5.27365 8.2827C5.28291 7.79764 5.29187 7.3275 5.29814 6.86663C9.78298 6.67726 13.3694 5.31778 16.4395 2.64243C19.5099 5.31778 23.0969 6.67741 27.582 6.86663C27.5883 7.32735 27.5973 7.79719 27.6065 8.28196C27.7606 16.3646 27.9342 25.5144 16.4395 29.6913Z"
        fill={props.fill}
      />
    </g>
    <defs>
      <clipPath>
        <rect fill={props.fill} height="32" width="32" />
      </clipPath>
    </defs>
  </svg>
);
